import LedgerManager from "@/components/admin/LedgerManager";

const COLUMNS = [
  { k: "tanggal", l: "Tanggal", t: "date" },
  { k: "rincian", l: "Rincian", t: "text" },
  { k: "volume", l: "Volume", t: "number" },
  { k: "satuan", l: "Satuan", t: "text" },
  { k: "harga", l: "Harga Satuan", t: "number" },
];

export default function LpjRabManager() {
  return <LedgerManager kind="rab" basePath="/keuangan/lpj-rab" title="LPJ RAB" columns={COLUMNS} />;
}
